import AboutBackgroundImage from "../Assets/about/lipe_champion.jpg";
import "./About.css";

const About = () => {
  const handleMetodologiaClick = () => {
    const element = document.getElementById("work");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="about" id="about" data-animate="fade-up" data-delay="200">
      <div className="about-container">
        <div className="about-content">

          <h1 className="about-title">Transformação além do físico</h1>

          <div className="about-image">
            <img src={AboutBackgroundImage} alt="Luís Felipe Sabóia - Atleta Wolfgang" />
          </div>

          <div className="about-text-block">
            <p className="about-description">
              Sou Luis Felipe Sabóia, profissional de Educação Física, atleta e treinador.
              Uno ciência do treinamento, periodização estratégica e dietética aplicada à{" "}
              <span className="about-highlight">
                prática real — tanto na minha própria preparação quanto na evolução dos meus alunos.
              </span>
            </p>

            <div className="about-actions">
              <button className="about-cta" onClick={handleMetodologiaClick}>
                Conheça a metodologia
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;